import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pager({ page, pages, total, onChange, testId = "pager" }) {
  if (!pages || pages <= 1) return total != null ? <p className="text-xs text-slate-400" data-testid={`${testId}-info`}>{total} data</p> : null;
  return (
    <div className="flex items-center justify-between gap-2 flex-wrap" data-testid={testId}>
      <p className="text-xs text-slate-400" data-testid={`${testId}-info`}>Halaman {page} dari {pages}{total != null ? ` · ${total} data` : ""}</p>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" className="h-9 min-w-[44px] rounded-lg bg-white/60 dark:bg-white/10 dark:border-white/15 dark:text-slate-100 dark:hover:bg-white/20" data-testid={`${testId}-prev`} disabled={page <= 1} onClick={() => onChange(page - 1)}><ChevronLeft className="h-4 w-4" /></Button>
        <Button variant="outline" size="sm" className="h-9 min-w-[44px] rounded-lg bg-white/60 dark:bg-white/10 dark:border-white/15 dark:text-slate-100 dark:hover:bg-white/20" data-testid={`${testId}-next`} disabled={page >= pages} onClick={() => onChange(page + 1)}><ChevronRight className="h-4 w-4" /></Button>
      </div>
    </div>
  );
}
